<template>
  <div class="md-layout md-alignment-center-center s1-U__flex-column s1-U__pd--tp40 s1-U__pd--bt40">
    <md-icon class="s1-U__mg--bt16 s1-loc__empty-state-icon">
      <span class="s1-U__text-color--dark-4">{{ icon }}</span>
    </md-icon>
    <p class="md-body-2 s1-U__text-color--dark-2 s1-U__mg--bt8">{{ message }}</p>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    icon: { type: String, default: 'help' },
    message: String
  }
}
</script>
